import { useLocation, useNavigate, useParams } from 'react-router-dom'
import posthog from 'posthog-js'
import Header from 'components/headers/addLoan'
import HandIcon from 'assets/images/easyPay/init.svg'
import useSetInitPayment from './hooks/useSetInitPayment'
import DotsLoading from 'components/loadings/dotsLoading'
import style from './payForOther.module.scss'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import AddJustPayForOtherModal from 'components/modals/addJustPayForOthers'
import EditIcon from 'assets/images/loans/edit.svg'
import useGetInitPaymentOs from 'pages/wallet/hooks/useGetInitPaymentOs'
import { NumericFormat } from 'react-number-format'
import Switch from 'react-switch'
import useGetMoneyPoolCashin from './hooks/useGetMoneyPoolCashin'
import {
    getActiveGateways,
    useActiveGatewayCode,
} from 'utilities/hooks/useIsDefaultGateway'
import GatewayPicker from 'components/gatewayPicker'
import ManualPaymentCard, {
    ManualPaymentReason,
} from 'components/manualPayment'
import useWalletCashin, {
    walletCashinPayload,
} from 'modules/easyPay/hooks/useWalletCashin'
import CommissionHint from 'components/commissionHint'

export default function PayForOther() {
    const { state } = useLocation()
    const initialUnpaid = Number(state?.item?.unpaid_portion)

    const {
        data: initData,
        isLoading,
        refetchWithAmount,
    } = useSetInitPayment(Number(state?.item?.id), initialUnpaid)
    const [lackOfWallet, setLackOfWallet] = useState<number>(0)
    const [isWallet, setIsWallet] = useState<boolean>(false)
    const [payment, setPayment] = useState<number>(initialUnpaid)
    // useEffect(() => {
    //     if (initData && !isOpenPayment) {
    //         setPayment(Number(state?.item?.unpaid_portion))
    //     }
    // }, [initData])
    useEffect(() => {
        if (state?.item?.unpaid_portion) {
            setPayment(Number(state.item.unpaid_portion))
        }
    }, [])
    const [isOpenPayment, setIsOpenPayment] = useState<boolean>(false)
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const { moneyPool } = useParams()

    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { data: walletData } = useGetInitPaymentOs(
        profile?.id,
        Number(initData?.commission),
        Number(payment)
    )

    const [jsonData, setJsonData] = useState<any>([])
    const [selectedCode, setSelectedCode] = useState<string | null>(null)

    const activeGateways = getActiveGateways(initData)
    useActiveGatewayCode(initData, setSelectedCode)

    // On a record-mode fund `init_pay` returns an empty gateway list on
    // purpose, so `selectedCode` never gets set. That must not disable
    // «ثبت پرداخت» too — a manager recording cash they already hold has no
    // gateway to pick, and demanding one turned this screen into a dead end
    // that could only toast «نوع درگاه پرداخت را انتخاب کنید».
    const recordBox =
        (initData as any)?.pay_mode === 'record'
            ? (initData as any)?.record_boxes?.[0]
            : undefined

    useEffect(() => {
        if (payment && moneyPool && initData && state) {
            setJsonData([
                {
                    moneyPool: Number(moneyPool),
                    amount: Number(payment) + Number(initData.commission),
                    ctxId: Number(moneyPool),
                    gateway: selectedCode === 'SMN_MPG' ? 5 : 9,
                    receiver: state?.item?.member?.id,
                    poolShip: state?.item?.id,
                    trustState: state.trustState,
                    commission: Number(initData.commission),
                    source: 'hwt',
                },
            ])
        }
    }, [payment, moneyPool, initData, state, lackOfWallet])
    const { mutate } = useGetMoneyPoolCashin(jsonData, 'pay_for_other')
    const { payFromWallet } = useWalletCashin('pay_for_other')

    useEffect(() => {
        if (initData && payment) {
            if (isWallet) {
                // What the wallet is actually debited is amount + commission
                // (`Transaction.total_amount`), so "covered" has to be decided
                // on the same number the shortfall is computed from.
                const due = Number(payment) + Number(initData.commission)
                const balance = Number(walletData?.wallet_balance ?? 0)
                setLackOfWallet(balance >= due ? 0 : due - balance)
            } else {
                setLackOfWallet(Number(payment) + Number(initData.commission))
            }
        }
    }, [initData, payment, isWallet, walletData])
    const navigate = useNavigate()

    return (
        <>
            <div className=" h-screen relative">
                <Header title="" />
                <div className="">
                    {initData && state && !isLoading ? (
                        <>
                            <div className=" relative">
                                <img
                                    src={HandIcon}
                                    alt="hand"
                                    className=" mx-auto absolute -top-16 z-50 right-32"
                                />

                                <div className={style['StyledReceipt']}>
                                    <div>
                                        <p>واریز به:</p>
                                        <p>همیان</p>
                                        <hr className=" mt-2" />
                                    </div>
                                    <div className=" flex justify-between mt-1">
                                        <p className="">مبلغ واریز به صندوق:</p>
                                        <div className={classNames('flex')}>
                                            {isOpenPayment ? (
                                                <NumericFormat
                                                    thousandSeparator
                                                    allowNegative={false}
                                                    name="totalObligationManager"
                                                    className=" border-1 border-gray-5 rounded-md bg-gray-5 text-center"
                                                    value={
                                                        payment
                                                            ? payment
                                                            : undefined
                                                    }
                                                    onValueChange={(values) => {
                                                        const { value } = values

                                                        setPayment(
                                                            Number(value)
                                                        )
                                                    }}
                                                />
                                            ) : (
                                                // <input
                                                //     type="number"
                                                //     min={0}
                                                //     className=" border-1 border-gray-5 rounded-md bg-gray-5 text-center"
                                                //     value={
                                                //         payment
                                                //             ? payment
                                                //             : undefined
                                                //     }
                                                //     onChange={(e) =>
                                                //         setPayment(
                                                //             Number(
                                                //                 e.target.value
                                                //             )
                                                //         )
                                                //     }
                                                // />
                                                <p>
                                                    {payment
                                                        ? Number(
                                                              payment
                                                          ).toLocaleString()
                                                        : state?.item
                                                              ?.unpaid_portion &&
                                                          state?.item?.unpaid_portion.toLocaleString()}{' '}
                                                    تومان
                                                </p>
                                            )}
                                            {isOpenPayment ? (
                                                <p
                                                    onClick={async () => {
                                                        const updated =
                                                            await refetchWithAmount(
                                                                payment
                                                            )
                                                        if (updated) {
                                                            setPayment(
                                                                updated.amount
                                                            )
                                                        }
                                                        setIsOpenPayment(false)
                                                    }}
                                                    className=" text-sm text-green-1 mr-2"
                                                >
                                                    اعمال
                                                </p>
                                            ) : (
                                                <img
                                                    src={EditIcon}
                                                    alt="edit"
                                                    className=" w-4 mr-2"
                                                    onClick={() =>
                                                        setIsOpenPayment(true)
                                                    }
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className=" flex justify-between items-start mt-2">
                                        <CommissionHint label="هزینه اشتراک:" />
                                        <p className=" shrink-0">
                                            {Number(
                                                initData.commission
                                            ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                    </div>
                                    <div className=" flex justify-between mt-2">
                                        <p className=""> بابت:</p>
                                        <p>پرداخت حق عضویت</p>
                                    </div>
                                    <div className=" flex justify-between mt-2">
                                        <p className="">نام صندوق:</p>
                                        <p>{state?.name}</p>
                                    </div>
                                    <div className=" flex justify-between mt-4">
                                        <div className="text-sm">
                                            <p>استفاده از کیف پول:</p>
                                            <p className=" text-text-gray">
                                                {walletData &&
                                                    walletData?.wallet_balance &&
                                                    walletData?.wallet_balance.toLocaleString()}{' '}
                                                تومان
                                            </p>
                                        </div>
                                        <Switch
                                            onChange={() =>
                                                setIsWallet(!isWallet)
                                            }
                                            checked={isWallet}
                                            onColor="#75B844"
                                            onHandleColor="#EAEEF0"
                                            handleDiameter={25}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            height={30}
                                            width={60}
                                            className="react-switch"
                                            id="material-switch"
                                            offColor="#B6BCC8"
                                        />
                                    </div>
                                    <hr className=" my-4" />
                                    <div className=" flex justify-between items-start mt-2">
                                        <div className=" min-w-0">
                                            <p className="">
                                                مبلغ کل قابل پرداخت:
                                            </p>
                                            <p className=" mt-1 text-[11px] leading-5 text-text-secondary">
                                                {isWallet
                                                    ? 'مبلغ واریز + هزینه اشتراک، پس از کسر کیف پول'
                                                    : 'مبلغ واریز + هزینه اشتراک'}
                                            </p>
                                        </div>
                                        <p className=" shrink-0">
                                            {isWallet
                                                ? Number(
                                                      lackOfWallet
                                                  ).toLocaleString()
                                                : Number(
                                                      payment +
                                                          initData.commission
                                                  ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                    </div>
                                </div>
                                <div className="px-4 my-4">
                                    {recordBox ? (
                                        <ManualPaymentCard
                                            info={recordBox.manual_payment}
                                            boxName={
                                                recordBox.box_name ||
                                                state?.name
                                            }
                                            amount={
                                                Number(payment) || undefined
                                            }
                                            source="pay_for_other"
                                            reason={
                                                (recordBox.reason as ManualPaymentReason) ??
                                                'no_gateway'
                                            }
                                            viewerIsManager={!!state?.isManager}
                                        />
                                    ) : (
                                        <GatewayPicker
                                            gateways={activeGateways}
                                            selectedCode={selectedCode}
                                            onSelect={setSelectedCode}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className=" bottom-10 absolute w-full">
                                <div
                                    className={
                                        recordBox ? ' hidden' : ' w-full'
                                    }
                                >
                                    <div
                                        className=" mx-8 rounded-2xl  bg-green-1 text-white text-center py-3 my-2 cursor-pointer"
                                        onClick={() => {
                                            posthog.capture(
                                                'payment_initiated',
                                                {
                                                    flow_type: 'pay_for_other',
                                                    amount: payment,
                                                    commission: (
                                                        initData as any
                                                    )?.commission,
                                                    moneypool_id: moneyPool,
                                                    gateway: selectedCode,
                                                    is_wallet: isWallet,
                                                }
                                            )
                                            if (!initData) return
                                            if (
                                                isWallet &&
                                                lackOfWallet === 0
                                            ) {
                                                // One POST settles it: the fund
                                                // is credited and the wallet
                                                // debited. This used to post
                                                // the same body to
                                                // /payment/transactions/ and
                                                // then redirect to a pay_url a
                                                // wallet payment never has.
                                                // Checked BEFORE the gateway:
                                                // no bank is involved, so
                                                // there is nothing to pick.
                                                payFromWallet(
                                                    walletCashinPayload({
                                                        poolshipId:
                                                            initData
                                                                ?.receivers?.[0]
                                                                ?.id,
                                                        moneypoolId:
                                                            Number(moneyPool),
                                                        amount: Number(payment),
                                                        type: 'cnp',
                                                        destination:
                                                            initData
                                                                ?.receivers?.[0]
                                                                ?.destination,
                                                    }) as any
                                                )
                                            } else if (selectedCode !== null) {
                                                mutate({
                                                    paymentItems: [
                                                        {
                                                            itemAmount:
                                                                Number(payment),
                                                            itemType:
                                                                initData
                                                                    ?.receivers?.[0]
                                                                    ?.type,
                                                            itemId: state?.item
                                                                ?.id,
                                                            box_id: Number(
                                                                moneyPool
                                                            ),
                                                            commission:
                                                                initData
                                                                    ?.receivers?.[0]
                                                                    ?.commission,
                                                            description:
                                                                'پرداخت حق عضویت',
                                                        },
                                                    ],
                                                    gateway: {
                                                        uniqueCode:
                                                            selectedCode,
                                                    },
                                                    clientType: 'pwa',
                                                    use_wallet: isWallet,
                                                })
                                            } else {
                                                toast.error(
                                                    'نوع درگاه پرداخت را انتخاب کنید'
                                                )
                                            }
                                        }}
                                    >
                                        پرداخت آنلاین
                                    </div>
                                </div>
                                {state?.isManager && (
                                    <div className=" w-full">
                                        <div
                                            // Primary when «پرداخت آنلاین»
                                            // above is hidden — see the note
                                            // on the same button in
                                            // payForothersInLoan.
                                            className={`mx-8 rounded-2xl text-center py-3 my-2 cursor-pointer ${
                                                recordBox
                                                    ? 'bg-green-1 text-white'
                                                    : 'border-1 border-green-1 bg-white text-green-1'
                                            }`}
                                            onClick={() => {
                                                // No gateway check: recording
                                                // is not a payment.
                                                if (initData) setIsOpen(true)
                                            }}
                                        >
                                            ثبت پرداخت
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    ) : (
                        <DotsLoading />
                    )}
                </div>
            </div>
            <AddJustPayForOtherModal
                show={isOpen}
                onHide={() => setIsOpen(false)}
            />
        </>
    )
}
